import React from 'react'
import CustomLink from "./customLink";

const AboutSection = () => {
    return (
        <section className="about-section olympiad-about" id="about">
            <div className="container" data-aos="fade-up">
                <div className="row order-change aos-init aos-animate" data-aos="fade-up">
                    <div className="col-md-12 col-lg-5" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="500">
                        <div className="img-box"><img src="/img/new-home/about.png" alt="About" /></div>
                    </div>
                    <div className="col-md-12 col-lg-6 offset-lg-1" data-aos="zoom-in" data-aos-delay="200" data-aos-duration="600">
                        <div className='data'>
                            <h2><span>About Practido</span></h2>
                            <p>Learning doesn’t have to feel heavy or boring, especially when students are preparing for a <span className='bold'>practice exam</span> or revising their concepts. At Practido, we’ve flipped the traditional learning model on its head. Instead of treating practice as a tiresome repetition, we turn it into an engaging, rewarding experience that students actually look forward to.</p>
                            <p>We understand a simple truth: kids love exploring new ideas, but mastering them requires consistent practice. That’s where most students lose momentum. So, we stepped in to transform practice into play, combining smart assessments with kids learning games, interactive challenges, and the gamification of learning to keep motivation high.</p>
                            <p>Practido blends educational depth with excitement, ensuring that every <span className='bold'>practice exam</span>, every math test, and every learning challenge feels like progress, not pressure.</p>      
                            <CustomLink
                            to="/practido-for-parents"
                            type="button"
                            className="btn blue-btn"
                            >
                            See Why Thousands of Parents Trust Practido
                            </CustomLink>  
                        </div>
                    </div>
                    {/* row */}
                </div>
            </div>
        </section>
    )
}

export default AboutSection